import React from 'react';
import LandingPage from './LandingPage';

/**
 * Home component that renders the landing page of the Flux Portal.
 */
function Home() {
  return <LandingPage />;
}

export default Home;